import { Component, OnInit } from '@angular/core'
import { TranslocoModule } from '@jsverse/transloco'
import { HttpClient } from '@angular/common/http'
import { ConfigService } from '../../services/config.service'

@Component({
   selector: 'app-help',
   standalone: true,
   imports: [TranslocoModule],
   templateUrl: './help.component.html',
   styles: ''
})
export class HelpComponent implements OnInit {

   translationParams = { llmModel: '' }

   constructor(private http: HttpClient, private config: ConfigService) {}

   ngOnInit() {
      this.fetchLlmModel()
   }

   private fetchLlmModel() {
      const url = `${this.config.apiUrl}/model`
      console.log(`URL: ${url}`)
      this.http.get<{model: string}>(url).subscribe({
         next: (response) => {
            if (response.model) {
               this.translationParams = {
                  llmModel: response.model
               }
            }
         },
         error: (err) => {
            console.error('Failed to fetch LLM model:', err)
         }
      })
   }


}
